import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { STATUS } from '@/core';
import theme from '@/theme';

export const PaymentStatusChip = ({ status }: { status: STATUS }) => {
  const { t } = useTranslation();
  return (
    <Chip
      label={t(`ORDER_STATUS.${status}`)}
      variant="filled"
      sx={{
        color: theme.palette.status[status].main,
        border: `1px solid ${theme.palette.status[status].main}`,
        backgroundColor: theme.palette.status[status].background,
      }}
    />
  );
};
